<div fxLayout="column" fxLayoutAlign="start">
	<div fxLayout="row" fxLayoutAlign="start start" *ngIf="showEdits">
		<div fxFlex>
			<h2 i18n="@@fundraiser_donation_status">Donation Status</h2>
		</div>
		<div class="cursor-pointer">
			<button mat-icon-button (click)="goToEditAmount()" id="editAmount">
				<img
					src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/edit/public"
					matTooltip="{{ this.editTooltip }}"
				/>
			</button>
		</div>
	</div>
	<div fxLayout="row" fxLayoutAlign="start start" *ngIf="showEdits">
		<mat-chip-listbox
			aria-label="category selection"
			id="chip-list"
			name="chip-list"
			class="whydonate-light"
		>
			<div *ngIf="this.isFindable">
				<mat-chip
					id="chip"
					name="chip"
					class="basic-chip"
					color="accent"
					selected
				>
					<caption i18n="@@target_amount_findable_on_search_page_toggle">
						Findable on search
					</caption>
				</mat-chip>
			</div>
			<div *ngIf="!this.isFindable">
				<mat-chip
					id="chip"
					name="chip"
					class="basic-chip"
					color="accent"
					selected
				>
					<caption i18n="@@target_amount_not_findable_on_search_page_toggle">
						Not Findable on search page
					</caption>
				</mat-chip>
			</div>

			<div *ngIf="this.isOpen">
				<mat-chip
					id="chip"
					name="chip"
					class="basic-chip"
					color="accent"
					selected
				>
					<caption i18n="@@create_fundraiser_fundraiser_status_radioGroup_open">
						open
					</caption>
				</mat-chip>
			</div>
			<div *ngIf="!this.isOpen">
				<mat-chip
					id="chip"
					name="chip"
					class="basic-chip"
					color="accent"
					selected
				>
					<caption
						i18n="@@create_fundraiser_fundraiser_status_radioGroup_close"
					>
						close
					</caption>
				</mat-chip>
			</div>
		</mat-chip-listbox>
	</div>
	<div fxLayout="row" fxLayoutAlign="start baseline" ngClass="m-t-m">
		<div fxFlex>
			<div id="donationAmount" class="mat-h1">
				<app-amount-view
					[fundraiserCardData]="fundraiserCardData"
					[offlineDonationAmount]="totalOfflineDonationAmount"
				></app-amount-view>
			</div>
		</div>
	</div>

	<div *ngIf="fundraiserCardData.showDonationAmount">
		<app-donation-progress-bar
			class="m-b-m"
			[fundraiserCardData]="fundraiserCardData"
			[offlineDonationAmount]="totalOfflineDonationAmount"
		></app-donation-progress-bar>
	</div>

	<div fxLayout="row" fxFill fxLayoutAlign="start center">
		<div fxLayout="column" fxFlex="50%" fxLayoutAlign="center start">
			<h3 id="fundedPercentage">
				<app-days-left-view
					[fundraiserCardData]="fundraiserCardData"
				></app-days-left-view>
			</h3>
		</div>
		<div fxLayout="column" fxFlex="50%" fxLayoutAlign="center end">
			<h3 id="fundedPercentage">
				<app-donation-progress-percentage
					[fundraiserCardData]="fundraiserCardData"
					[showLabel]="true"
					[offlineDonationAmount]="totalOfflineDonationAmount"
				></app-donation-progress-percentage>
			</h3>
		</div>
	</div>

	<div fxLayout="column" fxLayoutGap="5%">
		<div
			[matTooltip]="donationToolTipMessage"
			[matTooltipDisabled]="!isDraftOrClosed"
		>
			<button
				id="donateButton"
				mat-flat-button
				color="accent"
				[disabled]="
					isDraftOrClosed || isOpen == false || isLoading || !chargesEnabled
				"
				(click)="donate()"
				class="w-100"
			>
				<span i18n="@@button_donate"> Donate</span>
				<mat-icon *ngIf="isLoading" class="m-l-xs">
					<mat-spinner color="accent" diameter="16"> </mat-spinner>
				</mat-icon>
			</button>
		</div>
		<div
			matTooltip="Publish your fundraiser before sharing it"
			[matTooltipDisabled]="!isDraftOrClosed"
		>
			<button
				id="shareFundraiser"
				mat-stroked-button
				color="accent"
				[disabled]="isDraftOrClosed"
				[style.color]="'accent'"
				class="w-100"
				(click)="openShareDialog()"
				i18n="@@button_shareFundraiser"
			>
				Share Fundsraiser
			</button>
		</div>
		<div
			fxFlex="100%"
			fxLayout="row"
			fxLayoutGap="5%"
			*ngIf="isShowDonationAmount"
		>
			<img
				height="44px"
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/offlineBank/public"
			/>
			<p>
				<b>{{ currency_symbol }}&nbsp;{{ totalOfflineDonationAmount }}</b>
				&nbsp;<span i18n="@@offline_donation_added_manually"
					>was collected offline and added manually by the owner of this
					fundraiser. </span
				>&nbsp;<b>{{ currency_symbol }}&nbsp;{{ totalOnlineDonationAmount }}</b
				>&nbsp;<span i18n="@@offline_donation_collected_through_whydonate">
					was collected through WhyDonate.</span
				>
			</p>
		</div>
	</div>
</div>
<!-- <div fxLayout="row" fxLayoutAlign="center center">
</div> -->
